import {publish} from '@/script/event.mjs'

export const canSaveMap = () => () => {
    return function () {
        return this.actions.canSaveMap()
    }
}

export const saveMap = () => () => {
    return function () {
        return this.runAction(
            async () => {
                await this.actions.saveMap()
                publish(this, 'save')
            },

            {action: '保存地图'},
        )
    }
}
